// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination_root__0hAfI bg-white border-t border-solid border-gray gap-1 grid grid-flow-col justify-center px-0 py-xs text-center"};